<template>
<div>
  
  
      <div ref="drawer-background" :class="{'show':visible}" class="drawer-background" v-on:click.stop="closeDrawerMenu()">
        <div ref="drawer-menu" v-on:click.stop="closeDrawerMenu()" class="drawer-menu">
            <head-nav title="language.page_menu">
              <icon-button-ellipsis-h @click="closeDrawerMenu()" slot="left"></icon-button-ellipsis-h>
              <icon-button-home @click="closeDrawerMenu()" slot="right"></icon-button-home>
            </head-nav>
          <slot></slot>
        </div>
      </div>
    </div>
    


  
</template>

<script>
import { mapState } from 'vuex'
import IconButtonEllipsisH from './buttons/IconButtonEllipsisH.vue';
import IconButtonHome from './buttons/IconButtonHome.vue';

import HeadNav from './HeadNav.vue';
import anime from 'animejs/lib/anime.es.js';
import { eventBus } from '../services/EventBus.js';


export default {
  name: 'drawer-menu',
  data:function(){
    return {
      showing:false,
      visible:false,
    }
  },
  components:{
    IconButtonEllipsisH,
    IconButtonHome,
    HeadNav,
  },
  methods:{
    closeDrawerMenu(){
      if(!this.showing){
        return;
      }
      this.showing=false;
      this.startAnimation();
    },
    toggleDrawerMenu(){
      this.showing=!this.showing;

      this.startAnimation();
    },
    startAnimation(){
      if(this.showing){
        this.animateIn();
      }else{
        this.animateOut();
      }
    },
    animateIn(){
      
      this.visible=true;
      
      anime.remove(this.bg);
      anime.remove(this.menu)

       anime({
          targets: this.bg,
          opacity: 1,
          duration:250,
          easing: 'easeOutSine',
        }).finished.then(()=>{
          //
        });



        anime({
          targets: this.menu,
          translateX: ["-100%","0%"],
          duration:250,
          easing: 'easeOutSine',
        }).finished.then(()=>{
          //
        })



    },
    animateOut(){
      anime.remove(this.bg);
      anime.remove(this.menu)
      anime({
          targets: this.bg,
          opacity: 0,
          duration:250,
          easing: 'easeOutSine',
        }).finished.then(()=>{
          //
          this.visible=false;
        });

      anime({
          targets: this.menu,
          translateX: ["0%","-100%"],
          duration:250,
          easing: 'easeOutSine',
        }).finished.then(()=>{
          //
        })
      
    }
  },
  beforeDestroy(){
    this.showing=false;
     eventBus.$off('toggleDrawerMenu',this.toggleDrawerMenu);
  },
  mounted:function(){
    this.bg=this.$refs['drawer-background'];
    this.menu=this.$refs['drawer-menu'];
    eventBus.$on('toggleDrawerMenu',this.toggleDrawerMenu);
  },
  computed:mapState([
    'openDrawerMenu'
  ])
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.drawer-background{
  position:fixed;
  top:0;
  left:0;
  z-index:500000;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,.6);
  transform:translateX(-100%);
  opacity:0;
}
.show{
  transform:translateX(0);
}
.drawer-menu{
  display:flex;
  flex-direction:column;
  position:fixed;
  top:0;
  left:0;
  z-index:500010;
  width:80%;
  height:100%;
  background-color:#FFFFFF;
  transform:translateX(-100%);
}


/* background fading */
/*
.drawer-enter-active, .drawer-leave-active{
 
  transition: opacity .5s;
  z-index:500000;
  position:fixed;
  
}
.drawer-enter, .drawer-leave-to 
  
  opacity:0;
  z-index:500000;
  position:fixed;
 
}

.drawer-enter-active .drawer-menu, .drawer-leave-active .drawer-menu{
  
  transition: transform .5s;
  transform:translate(0%,0);
  z-index:500010;
}
.drawer-enter .drawer-menu, .drawer-leave-to .drawer-menu {
  
  transform:translate(-100%,0);
  z-index:500010;
}
*/
</style>

